import type {
    ProspectMatterType,
    ProspectPracticeArea,
    TemplateFormType,
    TemplateType,
} from '@common/enums';
import type { QuestionSchema, QuestionValidationSchema } from '@common/types/templateFormFields';
import type { FormGroup, TemplateFormMetadata } from '@common/types/templateForms';
import axiosInstance from '@/services/axiosInstance';

export interface DefaultQuestionPayload {
    name: string;
    title: string;
    subtitle: string;
    questionSchema: QuestionSchema;
    questionValidationSchema?: QuestionValidationSchema | null;
    displayOrder: number;
    isVisibleToUser: boolean;
    isLocked: boolean;
    formGroupTitle: string;
    overridenOfQuestion: number | null;
    lawFirmEntityMap: string;
    isRequiredForFullAutomation: boolean;
}

export interface SaveQuestionsAsDefaultPayload {
    lawFirmId: number | null;
    matterType: ProspectMatterType;
    templateType: TemplateType;
    templateFormType: TemplateFormType;
    practiceArea: ProspectPracticeArea;
    questions: DefaultQuestionPayload[];
    headerDescription: string | null;
    footerTemplate: string | null;
    formGroups?: FormGroup[];
    metadata?: TemplateFormMetadata | null;
}

export async function saveQuestionsAsDefault(payload: SaveQuestionsAsDefaultPayload) {
    return axiosInstance.post('api/v1/questions/defaults', payload);
}
